import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_DELETE_MODEL,
    REQUEST_LIST_MODEL,
    REQUEST_ADD_MODEL,
    REQUEST_LIST_MODEL_ALL,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import { CrudModel, EdgeServerID } from "userful-chronos-app-common-js/dist/models/eisenhower/edgeSetup";
import "./modelMsgReciever";

export const requestListModels = (payload: EdgeServerID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_MODEL, payload);
};

export const requestAddModel = (payload: CrudModel) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_MODEL, payload);
};

export const requestRemoveModel = (payload: CrudModel) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_DELETE_MODEL, payload);
};

export const requestListModelsAll = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_MODEL_ALL);
};
